import { render, staticRenderFns } from "./deviceAcess.vue?vue&type=template&id=a42c888e&scoped=true&"
import script from "./deviceAcess.vue?vue&type=script&lang=js&"
export * from "./deviceAcess.vue?vue&type=script&lang=js&"
import style0 from "./deviceAcess.vue?vue&type=style&index=0&id=a42c888e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42c888e",
  null
  
)

export default component.exports